<script>
export default {
    name: 'KpTextField',
    props: {
        maxLength: {
            type: Number,
            default: 0,
        },
    },

    mounted() {
        // because vuetify components do not make the maxlength attribute available, we need to set it programmatic
        if (this.maxLength > 0) {
            this.$refs.textfield?.$refs.input.setAttribute('maxlength', this.maxLength);
        }
    },
};
</script>

<template>
    <v-text-field ref="textfield" v-bind="$attrs" v-on="$listeners" />
</template>

<style scoped></style>
